import { cn } from '@/lib/utils';

// Visual twin: frontend/web/index.html `#boot-loader` paints the same SVGs before React
// mounts. Keep the two in sync if the brand mark changes.

interface BrandLoaderProps {
  readonly size?: 'sm' | 'md' | 'lg' | 'xl';
  readonly className?: string;
  readonly 'aria-label'?: string;
}

const SIZE_CLASSES: Record<NonNullable<BrandLoaderProps['size']>, string> = {
  sm: 'size-8',
  md: 'size-12',
  lg: 'size-16',
  xl: 'size-24',
};

export const BrandLoader = ({
  size = 'md',
  className,
  'aria-label': ariaLabel = 'Loading',
}: BrandLoaderProps) => {
  const sizeClass = SIZE_CLASSES[size];

  return (
    <output aria-label={ariaLabel} className={cn('relative inline-block', sizeClass, className)}>
      <img
        alt=""
        aria-hidden="true"
        className={cn('block size-full dark:hidden')}
        src="/svg/brand-loader-light.svg"
      />
      <img
        alt=""
        aria-hidden="true"
        className={cn('hidden size-full dark:block')}
        src="/svg/brand-loader-dark.svg"
      />
    </output>
  );
};
